import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../shared';
import { TemperatureModule } from '../temperature/temperature.module';

import { HeatingCurveComponent } from './components/heating-curve/heating-curve.component';

@NgModule({
  imports: [SharedDependenciesModule, TemperatureModule],
  declarations: [HeatingCurveComponent],
  exports: [HeatingCurveComponent],
})
export class HeatingCurveModule {}
